import React, { ElementType, forwardRef } from 'react';
import { cn } from '@/utils/styles';

interface AnchorProps extends Partial<Omit<HTMLElement, 'children'>> {
  id: string;
  as?: ElementType;
  topPadding?: number | string;
  children: React.ReactNode;
  className?: string;
}

const PaddedAnchor = forwardRef<HTMLDivElement, AnchorProps>(
  ({ id, as = 'section', topPadding, children, className, style }, ref) => {
    const Tag = as;
    return (
      <Tag style={style} ref={ref} className={cn('relative', className)}>
        <div
          id={id}
          className="absolute"
          style={{
            top: `${topPadding}`,
          }}
        />
        {children}
      </Tag>
    );
  },
);

PaddedAnchor.displayName = 'PaddedAnchor';
export default PaddedAnchor;
